import { useLocalSearchParams } from 'expo-router';
import { ConnectorSetupScreen } from '../../../components/connectors/ConnectorSetupScreen';

export default function ConnectorSetupRoute() {
  const { slug, name, rail, comingSoon } = useLocalSearchParams<{
    slug: string;
    name?: string;
    rail?: string;
    comingSoon?: string;
  }>();

  return (
    <ConnectorSetupScreen
      slug={slug}
      name={name ?? slug}
      rail={rail ?? 'ai'}
      comingSoon={comingSoon === '1'}
    />
  );
}
